import _ from 'lodash';

class ServiceContainer {
  static instances = new Map();

  static get(serviceName) {
    if (!this.instances.has(serviceName)) {
      throw new Error(`Service "${serviceName}" is not registered.`);
    }
    return this.instances.get(serviceName);
  }

  static register(serviceName, ServiceClass) {
    if (!this.instances.has(serviceName)) {
      this.instances.set(serviceName, new ServiceClass());
    }
  }
}

export const inject = (serviceName) => ServiceContainer.get(serviceName);

export function service(serviceNameOrTarget, maybeKey) {
  if (typeof serviceNameOrTarget === 'string') {
    const serviceName = serviceNameOrTarget;
    return function (target, key) {
      defineServiceProperty(target, key, serviceName);
    };
  }

  const target = serviceNameOrTarget;
  const key = _.kebabCase(maybeKey);
  defineServiceProperty(target, key, key);
}

function defineServiceProperty(target, key, serviceName) {
  let instance = ServiceContainer.get(serviceName);

  if (!target.constructor.__services) {
    target.constructor.__services = {};
  }

  target.constructor.__services[key] = instance;
}


export default ServiceContainer;
